import { KeyFunction } from "api/services/models/types";

export const keypad1: (KeyFunction & { name: string })[] = [
  { key: "1", function: "Play", description: "Begin playback", name: "playKey" },
  {
    key: "2",
    function: "Record - Start",
    description: "Begin recording new dictation",
    name: "recordKey"
  },
  {
    key: "3",
    function: "Short Review",
    description: "Rewind dictation by 5 seconds",
    name: "rewindKey"
  },
  { key: "4", function: "Pause", description: "Stop Recording or Playback", name: "pauseKey" },
  { key: "5", function: "Save Job", description: "Save dictation", name: "saveKey" },
  {
    key: "6",
    function: "Forward",
    description: "Forward dictation by 5 seconds",
    name: "forwardKey"
  },
  {
    key: "7",
    function: "End of Dictation",
    description: "Forward to end of the dictation",
    name: "eofKey"
  },
  {
    key: "8",
    function: "Start of dictation",
    description: "Rewind to start of the dictation",
    name: "bofKey"
  },
  { key: "9", function: "Abort", description: "Aborts current dictation", name: "abortKey" }
];

export const keypad2: KeyFunction[] = [
  {
    key: 2,
    function: "Record - Start/Stop",
    description: "Begin Recording or Stop recording."
  },
  { key: 22, function: "Overwrite", description: "Record over unwanted dictation." },
  { key: 3, function: "Short Review", description: "Review last few words." },
  { key: 4, function: "Forward", description: "Forward dictation by 5 secs." },
  { key: 44, function: "Forward to End", description: "Forwards to end of dictation." },
  { key: 5, function: "Disconnect", description: "End of dictation." },
  { key: 6, function: "Priority", description: "Change Priority from normal to STAT." },
  { key: 77, function: "Rewind to Start", description: "Rewinds to start of dictation." },
  {
    key: 8,
    function: "Multiple Documents",
    description: "Start new dictation without hanging up."
  }
];